type Task = {
  id: number;
  name: string;
  superUser: boolean;
  readOnlyUser: boolean;
  networkPlanner: boolean;
  riskManager: boolean;
  launchTeam: boolean;
  calculationTrigger: boolean;
};

export const userTasks: Task[] = [
  {
    id: 1,
    name: "Create, edit and delete carrier and carrier branch data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: true,
    calculationTrigger: false,
  },
  {
    id: 2,
    name: "Create, edit and delete supplier data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: true,
    calculationTrigger: false,
  },
  {
    id: 3,
    name: "Create, edit and delete plant and dock data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 4,
    name: "Create, edit and delete EDC data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 5,
    name: "Create, edit and delete ODC & Other data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 6,
    name: "Create, edit and delete contact data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: true,
    launchTeam: true,
    calculationTrigger: false,
  },
  {
    id: 7,
    name: "Create, edit and delete bid pack data and special handling times",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 8,
    name: "Create, edit and delete rate agreement data and TT & cut off times",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 9,
    name: "Assign bid pack to rate agreement",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 10,
    name: "Create, edit and delete SPDR data (Inbound Network)",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 11,
    name: "Create, edit and delete PDSR data (Return Network)",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 12,
    name: "Create, edit and delete project data",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 13,
    name: "Propose projects",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 14,
    name: "Set launch date for proposed FTL routes",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 15,
    name: "Trigger SPDR Overview calculation",
    superUser: false,
    readOnlyUser: false,
    networkPlanner: false,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: true,
  },
  {
    id: 16,
    name: "Trigger PDSR Overview calculation",
    superUser: false,
    readOnlyUser: false,
    networkPlanner: false,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: true,
  },
  {
    id: 17,
    name: "Trigger FTL and LTL route launcher",
    superUser: false,
    readOnlyUser: false,
    networkPlanner: false,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: true,
  },
  {
    id: 18,
    name: "Create, edit, delete and approve PDSR validation items",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: true,
    riskManager: false,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 19,
    name: "Create edit transit time protections",
    superUser: true,
    readOnlyUser: false,
    networkPlanner: false,
    riskManager: true,
    launchTeam: false,
    calculationTrigger: false,
  },
  {
    id: 20,
    name: "Pull reports from all screens and tables",
    superUser: true,
    readOnlyUser: true,
    networkPlanner: true,
    riskManager: true,
    launchTeam: true,
    calculationTrigger: false,
  },
  {
    id: 21,
    name: "View, search, filter and sort data in all screens and tables",
    superUser: true,
    readOnlyUser: true,
    networkPlanner: true,
    riskManager: true,
    launchTeam: true,
    calculationTrigger: false,
  },
];
